// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"c0fa47d8","885":"370c1a21"}[chunkId] + ".chunk.js";
};